import React from "react";
import { useSelector } from "react-redux";
import { Modal, Container } from "react-bootstrap";
import ItemList from '../../containers/ItemList/ItemList'

import './ConciliationHistoryResultModal.scss';

import messages from "../../assets/i18n";

function ConciliationHistoryResultModal(props) {

	const lang = useSelector(state => state.language.name);
	const pageMessages = messages[lang].conciliationHistoryListPage;

	const header = [
		pageMessages.dtConciliacaoComercial,
		pageMessages.motivoReprovacao,
		pageMessages.observacao
	];


	const mappedHistoryList = () => {
		return props.history.map((item) => {
			return [
					{
						text: item.dtConciliacaoComercial,
						type: 'datehour',
					},
                    { 
						text: item.motivoReprovacao,
						className: 'line-break-justify',
						maxLength: 400000
					},
					{ 
						text: item.observacao,
						className: 'line-break-justify',
						maxLength: 400000
					}
				]
		});
	}

	return (
		<Modal
			{...props}
			aria-labelledby="contained-modal-title-vcenter"
			className="conciliation-history-result-modal"
			centered
		>
			<Modal.Header className="text-left" closeButton>
				<Modal.Title className="w-100 font-weight-bold">
					{pageMessages.title}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Container className="px-0 mb-5 pb-5">
					<ItemList
                        header={header}
                        titleTable={pageMessages.title}
                        listTable={mappedHistoryList()}
                        isLoading={props.history.length > 0 ? false : true}
                        />
				</Container>

			</Modal.Body>
		</Modal>
	)
}

export default ConciliationHistoryResultModal;